import axiosInstance from 'api/axiosInstance';
import { URL_SEARCH_CUSTOMERS } from 'constants/urls';

/**
 * Search customers (companies) with pagination
 * Note: This API expects a JSON payload parameter using custom paramsSerializer
 *
 * @param {string} searchKeyword - Search term
 * @param {number} page - Page number (default: 1)
 * @param {number} take - Items per page (default: 100)
 * @returns {Promise<{data: Array, totalCount: number}>}
 */
const searchCustomers = async (searchKeyword = '', page = 1, take = 100) => {
  const payload = {
    SearchKeyword: searchKeyword,
    Page: page,
    Take: take,
  };

  const { data } = await axiosInstance({
    method: 'GET',
    url: URL_SEARCH_CUSTOMERS,
    params: payload,
    paramsSerializer: (params) => `payload=${JSON.stringify(params)}`,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    data: null,
  });

  return {
    data: data.Data || [],
    totalCount: data.TotalResults || 0,
  };
};

export default searchCustomers;
